import {Concept} from 'types';
import type {Column, PostInfoApiArgs, PostInfoArgs} from '../types';
import {
  filterColumnsByType,
  filterIsSearchable,
  getFilterValuesByName,
} from '../functions';
import {mapToFilters} from './mapFilters';
import {mapViewMode} from './mapViewMode';

export const mapPostInfoApiArgs = (
  {type, filters, columns, distinctOn, sort, page, size}: PostInfoArgs,
  allColumns: Column[],
): PostInfoApiArgs | undefined => {
  // Move EQUAL ean filter into a separate more performant parameter.
  const eans = getFilterValuesByName('ean', filters, 'EQUAL');
  // Move workId filter into a separate more performant parameter.
  const workIds = getFilterValuesByName('workId', filters);

  // Map to api filters and remove non-searchable filters.
  const apiFilters = mapToFilters(filters.filter(filterIsSearchable), false);

  const filteredColumns = filterColumnsByType(allColumns, type, columns);

  // Invalid requst, abort.
  if (
    (apiFilters?.length ?? 0) === 0 &&
    (eans?.length ?? 0) === 0 &&
    (workIds?.length ?? 0) === 0 &&
    (filteredColumns?.length ?? 0) === 0
  ) {
    return;
  }

  return {
    type: mapViewMode(type),
    filters: apiFilters,
    columns: filteredColumns,
    distinctOn,
    eans: eans ?? [],
    workIds: workIds,
    sort: type === Concept.work ? undefined : sort,
    page: page ?? 0,
    size: size ?? 20,
  };
};
